import axios from 'axios';
import { configRefs } from '@utils/constants';
import { mapApiResponseToCourseModel } from './utils/api-to-course.js';

async function getCoursesForTeacherRequest(teacher) {
  const response = await axios.get(`${await configRefs.apis.userdata.get()}/api/v2/Courses?userID=${encodeURIComponent(teacher.id)}`);
  return response.data.map(it => mapApiResponseToCourseModel(teacher, it));
}

export { getCoursesForTeacherRequest };
//# sourceMappingURL=request.get-all.teacher.js.map
